import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 19 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.84 14.51c.135-.409.37-.79.677-1.098l4.76-4.741V5.625h-4.94c-.39 0-.68-.314-.68-.703V0H2.108C.946 0 0 .946 0 2.11v19.78C0 23.055.946 24 2.11 24h14.039c1.163 0 2.128-.946 2.128-2.11v-5.247l-.773.754c-.313.31-.68.536-1.093.674l-2.235.746-.34.02a1.77 1.77 0 0 1-1.428-.733 1.76 1.76 0 0 1-.239-1.584zm-9.324-1.854h7.008a.703.703 0 1 1 0 1.406H3.516a.703.703 0 1 1 0-1.406m-.703-2.11c0-.388.314-.702.703-.702h7.008a.703.703 0 1 1 0 1.406H3.516a.703.703 0 0 1-.703-.703m0 5.626c0-.389.314-.703.703-.703h7.008a.703.703 0 1 1 0 1.406H3.516a.703.703 0 0 1-.703-.703m10.523 3.515a.703.703 0 1 1 0 1.407H9.119a.703.703 0 1 1 0-1.407zm-9.82-11.25a.703.703 0 1 1 0-1.406h9.82a.703.703 0 1 1 0 1.407z" }, null, -1)
  ])))
}
export default { render: render }